import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';

// 获取麦上人员列表
interface MicPersonListParams {
  fromType: number;
  roomId: number;
  userId: number;
}

export interface micPersonListJson {
  micIndex: number;
  isSdk: boolean;
  closeMicStatus: boolean;
  micStatus: number;
  shieldStatus: boolean;
  stayRoomId: number;
  userId: number;
  userName: string;
  userUrl: string;
  isMute: boolean;
  roleId: number;
  sex: number;
}

export function micPersonList(params: MicPersonListParams) {
  return request<micPersonListJson[]>({
    method: 'GET',
    url: httpApi.voice.micPersonList,
    params
  });
}

// 上下麦
export interface MicOperateData {
  fromType: number;
  isSdk: boolean;
  micIndex: number;
  operateType: number;
  operateUserId: number;
  roomId: number;
  userId: number;
}

export function micOperate(data?: MicOperateData) {
  return request<any>({
    method: 'POST',
    url: httpApi.voice.micOperate,
    data
  });
}

// 获取用户信息
export interface NormalPersonParams {
  fromType: number;
  roomId: number;
  uid: number;
  isSdk?: boolean;
  userId: number;
}

export interface medalJson {
  fold: string;
  id: number;
  lv: number;
  name: string;
  unfold: string;
}

export interface normalPersonJson {
  fansNum: number;
  flagTheme: any;
  followNum: number;
  collectNum: number;
  imgUrl: string;
  isBaned: boolean;
  isFollow: boolean;
  medal: medalJson;
  micIndex: number;
  micStatus: boolean;
  name: string;
  onMic: boolean;
  roomId: number;
  sex: number;
  showRoomId: string;
  uid: number;
  userName: string;
  roleId: number;
  age: number;
  account: string;
  isSdk: boolean;
  isPrivateChat?: boolean;
}

export interface UserItemJson {
  data?: boolean;
  roleId?: number;
  isBanned?: boolean;
  isPrivateChat?: boolean;
  sex?: number;
}

export function normalPerson(params: NormalPersonParams) {
  return request<normalPersonJson>({
    method: 'GET',
    url: httpApi.voice.normalPerson,
    params
  });
}

export interface modalInfoJson {
  uid: number;
  roleId: number;
  modalShow: boolean;
  isSdk: boolean;
}

// 关注、取关
interface FollowData {
  action: number;
  roomId: number;
  userId: number;
  live_platform?: string;
}

export function follow(data: FollowData) {
  return request({
    method: 'POST',
    url: httpApi.voice.follow,
    data
  });
}

// 禁言，取消禁言
interface FollowParams {
  fromType: number;
  isSdk?: boolean;
  operateType: number;
  operateUserId?: number;
  roomId: number;
  userId: number;
}

export function banOperate(params: FollowParams) {
  return request({
    method: 'GET',
    url: httpApi.voice.banOperate,
    params
  });
}
